import { fromEvent, Subscription } from "rxjs";

import { GamePage } from "../interfaces";
import TitleMenu from "./title-menu";

import html from "./settings-menu-html";

import SettingsSaver from "../settings-saver";

export default class SettingsMenu implements GamePage {
  public menu: HTMLElement;
  public loaded: boolean;
  public tornDown: boolean;
  public routerId: string;
  public name: string = "settings";

  private titleMenu: TitleMenu;
  private subscriptions: Subscription[] = [];
  private settings: SettingsSaver;

  constructor() {
    this.menu = document.createElement("div");
    this.menu.classList.add("encourage-wrapper");
    this.menu.insertAdjacentHTML("beforeend", html);
    this.loaded = false;
    this.tornDown = false;
    this.titleMenu = new TitleMenu();
    this.routerId = "";
    this.settings = new SettingsSaver();

    const params = new URLSearchParams(location.search);
    const path = params.get("back-link");

    const link = this.menu.querySelector("#js-settings-back-link");
    link.setAttribute("href", path);
  }

  configurePrograms() {
    this.titleMenu.configurePrograms();
  }

  tearDown() {
    console.log("Tearing down settings menu...");
    this.tornDown = true;
    this.titleMenu.tearDown();
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  tick(timestamp: number) {
    this.titleMenu.tick(timestamp);
  }

  async load(params) {
    await this.titleMenu.load(params);

    const soundOn = this.menu.querySelector("#js-sound-on") as HTMLInputElement;
    soundOn.checked = this.settings.soundOn;

    const soundOnSub = fromEvent(soundOn, "change").subscribe(e => {
      this.settings.soundOn = (e.target as HTMLInputElement).checked;
    });

    this.subscriptions.push(soundOnSub);
    this.loaded = true;
  }

  start() {}
}
